import {
  DecorativeElement,
  COMPONENTS,
  DOT_COLORS,
  DOT_CLASSES,
} from "../../../componentsGLob/Decorative/decorative-element.config";

export const HERODIGI_DECORATIVES: DecorativeElement[] = [
  {
    id: "hero-digital-dig-bee-1",
    type: "bee",
    Component: COMPONENTS.Bee,
    position: "top-[3%] left-[10%] md:left-[20%]",
    animation: {
      animate: {
        x: [0, 15, 30, 15, 0, -15, -30, -15, 0],
        y: [0, -10, 0, 10, 20, 10, 0, -10, 0],
        rotate: [0, 15, 0, -15, 0, 15, 0, -15, 0],
      },
      transition: {
        duration: 20,
        repeat: Infinity,
        repeatType: "loop",
        ease: "easeInOut",
      },
    },
    className: "hidden xl:block",
  },

  {
    id: "hero-digital-arrow-1",
    type: "arrow",
    Component: COMPONENTS.ArrowIcon,
    position: "top-[20%] right-[10%] md:right-[15%]",
    animation: {
      animate: {
        y: [0, 16, 0],
      },
      transition: {
        duration: 1.8,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className:
      "w-16 h-16 md:w-20 md:h-20 opacity-90 rotate-[120deg] hidden xl:block",
  },
  {
    id: "hero-digital-arrow-2",
    type: "arrow",
    Component: COMPONENTS.ArrowIcon,
    position: "top-[50%] left-[6%] md:left-[6%]",
    animation: {
      animate: {
        y: [0, 16, 0],
      },
      transition: {
        duration: 1.8,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className:
      "w-16 h-16 md:w-20 md:h-20 opacity-90 rotate-[340deg] hidden xl:block",
  },
  {
    id: "hero-digital-dot-red-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[8%] left-[9%]",
    animation: {
      animate: {
        x: [0, 8, -6, 4, 0],
        y: [0, -10, 5, -6, 0],
        rotate: [0, 5, -5, 3, 0],
      },
      transition: {
        duration: 10,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.red} ${DOT_CLASSES.small}`,
  },
  {
    id: "hero-digital-dot-yellow-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[18%] right-[8%]",
    animation: {
      animate: {
        x: [0, 10, -10, 5, 0],
        y: [0, -10, 10, -5, 0],
        rotate: [0, 4, -4, 2, 0],
      },
      transition: {
        duration: 12,
        repeat: Infinity,
      },
    },
    className: `${DOT_COLORS.yellow} ${DOT_CLASSES.small}`,
  },
  {
    id: "hero-digital-dot-cyan-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[6%] right-[3%]",
    animation: {
      animate: {
        x: [0, 15, -15, 10, -10, 0],
        y: [0, -15, 15, -10, 10, 0],
        rotate: [0, 10, -10, 5, -5, 0],
      },
      transition: {
        duration: 22,
        repeat: Infinity,
      },
    },
    className: `${DOT_COLORS.cyan} ${DOT_CLASSES.medium}`,
  },
];
